import styled from "styled-components";

/* ----------------- WRAPPERS ----------------- */
export const Container = styled.div`
  font-family: Roboto, system-ui, -apple-system, Segoe UI, Arial, sans-serif;
  padding: 100px 16px;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  @media (max-width: 767px) {
    padding: 50px 16px;
  }
`;

export const Title = styled.h1`
  color: #111;
  font-size: 36px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 1.08px;
  margin-bottom: 36px;
`;

/* ----------------- GRID ----------------- */
export const Form = styled.form`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 32px 16px;

  /* Layout desktop (>= 768px) */
  grid-template-areas:
    "nome nome nome nome nome nome"
    "data data data genero genero genero"
    "cep  cep  cep   rua   rua   rua"
    "numero numero numero complemento complemento complemento"
    "bairro bairro uf uf    cidade cidade"
    "telefone telefone telefone email email email"
    "vaga vaga vaga disponibilidade disponibilidade disponibilidade"
    "possui possui possui escolaridade escolaridade escolaridade"
    "resumo resumo resumo resumo resumo resumo"
    "anexo anexo anexo anexo anexo anexo"
    "inputfile inputfile inputfile inputfile inputfile inputfile"
    "botao botao botao botao botao botao";

  /* Responsivo: empilha tudo no mobile */
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "nome"
      "data"
      "genero"
      "cep"
      "rua"
      "numero"
      "complemento"
      "bairro"
      "uf"
      "cidade"
      "telefone"
      "email"
      "vaga"
      "disponibilidade"
      "possui"
      "escolaridade"
      "resumo"
      "anexo"
      "inputfile"
      "botao";
  }
`;

export const Nome = styled.div`
  grid-area: nome;
`;
export const Data = styled.div`
  grid-area: data;
`;
export const Genero = styled.div`
  grid-area: genero;
`;

export const Cep = styled.div`
  grid-area: cep;
`;
export const Rua = styled.div`
  grid-area: rua;
`;

export const Numero = styled.div`
  grid-area: numero;
`;
export const Complemento = styled.div`
  grid-area: complemento;
`;

export const Bairro = styled.div`
  grid-area: bairro;
`;
export const Uf = styled.div`
  grid-area: uf;
`;
export const Cidade = styled.div`
  grid-area: cidade;
`;

export const Telefone = styled.div`
  grid-area: telefone;
`;
export const Email = styled.div`
  grid-area: email;
`;

export const Vaga = styled.div`
  grid-area: vaga;
`;
export const Disponibilidade = styled.div`
  grid-area: disponibilidade;
`;

export const Possui = styled.div`
  grid-area: possui;
`;
export const Escolaridade = styled.div`
  grid-area: escolaridade;
`;

export const Resumo = styled.div`
  grid-area: resumo;
`;

export const Anexo = styled.div`
  grid-area: anexo;

  h2 {
    color: #111;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
  }

  span {
    color: #ee0000;
  }
`;
export const InputFileRow = styled.div`
  grid-area: inputfile;
  > * {
    min-width: 100%;
  }
`;

export const Botao = styled.div`
  grid-area: botao;
  justify-self: end;
`;

export const FIleUploadContainer = styled.div`
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.16);
  background: #f6f6f9;
  width: 296px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;

  > img {
    cursor: pointer;
  }

  > div:nth-child(1) {
    display: flex;
    gap: 8px;
    align-items: center;

    p {
      color: #3e4e65;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }
`;
